import React from 'react'

import { useMessage } from '../../hooks/message'
import { EXPENSE_REPORT_LIST } from '../../urls'
import { usePostRequest } from '../../hooks/request'
import ExpenseRemoveForm from './expense-remove-form'

export default function ExpenseRemove({ onCancel, categoryList, expenseReport, brandList }) {
    const products = usePostRequest({ url: EXPENSE_REPORT_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success, error } = await products.request({ data })
        if (success) {
            expenseReport.request()
            onCancel()
            showMessage('Успешно добавлен', 'is-success')
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Вычесть</b>
            </h1>
            <ExpenseRemoveForm loading={products.loading} categoryList={categoryList} brandList={brandList} onCancel={onCancel} onSubmit={onSubmit} />
        </div>
    )
}
